import React from "react";
import FeedbackForm from "./FoodFeedBack";

export const foodFeedbackConfig = {
  title: "Food Feedback",
  subtitle: "Submit feedback for any meal of the day.",
  mealTypes: ["Breakfast", "Lunch", "Dinner"],
  ratingFields: [
    { key: "taste", label: "Taste" },
    { key: "quantity", label: "Quantity" },
    { key: "hygiene", label: "Hygiene & cleanliness" },
    { key: "variety", label: "Variety" },
  ],
  recommendQuestion: "Would you recommend today's meal to others?",
  onSubmitDay: async (payload) => {
    console.log("Food feedback submitted:", payload);
  },
};

export const roomFeedbackConfig = {
  title: "Room Feedback",
  subtitle: "Let us know how your room and hostel facilities are.",
  ratingFields: [
    { key: "cleanliness", label: "Cleanliness" },
    { key: "comfort", label: "Comfort" },
    { key: "maintenance", label: "Maintenance & repairs" },
    { key: "facilities", label: "Facilities (water, electricity, wifi)" },
  ],
  recommendQuestion: "Would you recommend this room setup to others?",
  onSubmitDay: async (payload) => {
    console.log("Room feedback submitted:", payload);
  },
};

export default function FoodFeedbackForm({lessonPlanIdentity }) {

  let getCourse = localStorage.getItem("course_co");
  let course_get = JSON.parse(getCourse || "{}");

  return (
    <FeedbackForm
      course_get={course_get}
      lessonPlanIdentity={lessonPlanIdentity}
      sections={{
        food: { label: "Food", accent: "green", config: foodFeedbackConfig },
        room: { label: "Room", accent: "teal", config: roomFeedbackConfig },
      }}
    />
  );
}